<template>
  <div id="services-wrapper">
    <div
      id="services-content"
      class="Services single-service-scroller"
    >
      <!-- SEO TITLE -->

      <section
        class="Services__header scroll-services-header"
        data-nosnippet
      >
        <img
          v-if="$store.state.isMobile && content.header_image_mb"
          :data-src="getImageKitURL(content.header_image_mb, 1, content.image_type,false, position)"
          :src="getImageKitURL(content.header_image_mb, 1, content.image_type,false, position)"
          :alt="content.header_image_mb.alt"
          class="Services__header--image"
        >
        <img
          v-else
          :data-src="getImageKitURL(content.header_image, 1, content.image_type,false, position)"
          :src="getImageKitURL(content.header_image, 1, content.image_type,false, position)"
          :alt="content.header_image.alt"
          class="Services__header--image"
        >
        <iframe
          v-if="$store.state.isMobile && content.header_vimeo_id_mb"
          :src="`https://player.vimeo.com/video/${content.header_vimeo_id_mb}?background=1`"
          width="640"
          height="360"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
          title="About Video"
        />
        <iframe
          v-else
          :src="`https://player.vimeo.com/video/${content.header_vimeo_id}?background=1`"
          width="640"
          height="360"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
          title="About Video"
        />

        <div
          v-if="$store.state.isMobile"
          class="Services__header--content"
        >
          <TextWeAreBinalogue />
          <!-- <TextWeAreBinalogueResponsive /> -->
        </div>

        <div
          v-else
          class="Services__header--content"
        >
          <TextWeAreBinalogue />
        </div>
      </section>
      <main class="Services__content">
        <div class="Services__left">
          <h1 class="Services__title">
            {{ content.title }}<span class="orange">.</span>
          </h1>
          <h2 class="Services__subtitle main-text orange">
            {{ content.subtitle }}
          </h2>
        </div>
        <div class="Services__right" />
      </main>


      <section
        v-for="category in content.services_categories_list"
        :key="category.slug"
        class="Services__cards"
      >
        <div
          v-for="service in category.services"
          :key="service.slug"
          class="Services__cards--item"
        >
          <InertiaLink
            :href="`/services/${service.slug}/`"
            class="Services__cards--title black medium-title"
          >
            {{ service.title }}<span class="orange">.</span>
          </InertiaLink>
          <div
            class="Services__cards--description main-text"
            v-html="service.description"
          />
        </div>
      </section>

      <span id="services-content-footer" />
      <TheFooter />
    </div>
  </div>
</template>

<script>
/* Vendor */
import { nextTick } from 'vue';
import { InertiaLink } from "@inertiajs/inertia-vue3";

/* Helpers */
import { mainLayout } from "@/helpers/vue-layouts";
import seo from "@/helpers/seo";

/* Mixins */
import page from "@/mixins/page";
import imageKit from "@/mixins/image-kit";
import scrollGlobal from "@/mixins/scroll-global";
import loader from "@/mixins/loader";

export default {
  components: {
    InertiaLink
  },

  mixins: [page, scrollGlobal, loader, imageKit],

  layout: mainLayout,

  props: {
    content: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      headerColorinit: null,
      bgScrollAnimation:null,
    };
  },

  created() {
    seo.seoContent(this.content);
  },

  mounted() {
    this.$nextTick(() => {
      // console.log('init images' );
      this.imagesToPreload = document.querySelectorAll("img");
      // console.log('home page imgs',this.imagesToPreload  );
      this.getBackgroundImagesUrl();
      this.loadImages();
    });
  },

  beforeUnmount() {
    this.bgScrollAnimation.scrollTrigger.kill();
    this.$gsap.to('.hideInAvatar', {opacity:1, duration:0.4});
  },

  methods: {
    init() {
      this.toggleMenuColor("white", 0,0);
      // this.$gsap.to('.hideInAvatar', {opacity:0, duration:0.4});
      this.setScroller('#services-wrapper', '#services-content' );

      // HEADER ANIMATIONS
      this.bgScrollAnimation = this.$gsap.to('.showBgHeader', {
        scrollTrigger: {
          trigger: '#services-content',
          markers: false,
          onEnter: this.updateHeaderState,
          onEnterBack: this.updateHeaderStateBack,
          start: '50px top',
          end: 'top bottom',
          toggleActions: 'play none reverse none',
        },
        height: '100%',
        duration: 0.2,
        ease: 'Power2.out',
      });
    },

    updateHeaderState(){
      this.toggleMenuColor('black', 0.2, 0);
      // this.$gsap.to('.hideInAvatar', {opacity:1, duration:0.4});
    },

    updateHeaderStateBack(){
      this.toggleMenuColor('white', 0.2, 0.4);
      // this.$gsap.to('.hideInAvatar', {opacity:0, duration:0.4});
    },

  }
}
</script>

<style lang="scss">
.Services {
  display: flex;
  flex-direction: column;
  max-width: 100vw;
  overflow-x: hidden;
  width: 100%;
  @include headerMargin;

  &__header {
    position: relative;
    display: flex;
    overflow: hidden;
    background: $black;
    width: 100vw;
    height: 100vh;

    @include tablet {
      height: initial;
    }

    iframe {
      position: absolute;
      top: 0;
      left: 50%;
      z-index: 1;
      transform: translateX(-50%);
      width: 177.7vh;
      height: 100vh;

      @include tablet {
        position: relative;
        width: 100vw;
        height: 56.25vw;
      }
    }

    &--image {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100vw;
      height: 100vh;
      object-fit: cover;

      @include tablet {
        height: auto;
      }

    }

    &--content {
      position: relative;
      top: 0;
      left: 0;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100vw;
      height: 100vh;

      @include tablet {
        position: absolute;
        width: 100vw;
        height: 56.25vw;
      }

      svg {
        max-width: 900px;
        width: 85vw;

        @include tablet {
          width: 49vw;
        }
      }
    }

    &--title {
      padding-left: 5vw;
      font-size: 15vw;
      line-height: 1;
      color: $white;
      text-shadow: 0.3vw 0.3vw 2vw rgba($black, 0.7);
      font-variation-settings: "wght" 800, "wdth" 100, "opsz" 30;
      @include transition;

      strong {
        margin-left: -1vw;
        color: $orange;

        @include desktop-l {
          margin-left: -18px;
        }
      }

      em {
        font-style: normal;
        color: $orange;
      }

      @include tablet {
        padding-left: 0;
        font-size: 5vw;
      }

      @include desktop-l {
        font-size: 90px;

        p {
          width: 110%;
        }
      }

      &:hover {
        color: $orange;

        em {
          color: $black;
        }
      }
    }
  }

   &__description {

    p {
     margin-bottom: 15px;
    }

    h2, h3 {
       margin-bottom: 15px;
      font-size: 22px;
      line-height: 1.1;
      font-variation-settings: 'wght' 600, 'wdth' 100, 'opsz' 30;

      @include desktop-sm {
        font-size: 30px;
      }

      @include desktop-l {
        font-size: 34px;
      }

      @include desktop-xl {
        font-size: 34px;
      }
    }

    li {
      position: relative;
      padding-left: 15px;
      list-style: none;

       @include desktop-sm {
          padding-left: 20px;
        }

      &::before {
        position: absolute;
        top: 12px;
        left: 0;
        content: '';
        background: $orange;
        transform: translateY(-50%);
        width: 8px;
        height: 8px;
         @include tablet {
              top: 15px;
            }

        @include desktop-sm {
          width: 10px;
          height: 10px;
          top: 17px;
        }

        @include desktop-l {
          top: 20px;
        }

        @include desktop-xl {
          top: 23px;
        }
      }
    }
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 100vw;
    overflow-x: hidden;

    @include paddingTop;
    @include paddingMobile;
    @include paddingBottom;

    @include tablet {
      @include paddingBig;

      padding-bottom: 0;
    }
  }

  &__left {
    width: 100%;
     @include paddingMobileBottom;

     @include tablet-m {
      width: 35%;

     }
  }


  &__title {
     font-size: 32px;
    line-height: 1;
    font-variation-settings: 'wght' 750, 'wdth' 100, 'opsz' 30;
    width: 100%;


    @include tablet {
          font-size: 48px;
      line-height: 1.1;
    }
      @include desktop-sm {
      font-size: 54px;
    }

    @include desktop-l {
      font-size: 64px;
    }

    @include desktop-xl {
      font-size: 74px;
    }

  }

  &__right {
    width: 100%;

    @include tablet-m {
      width: 55%;

    }


  }

  &__cards {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      @include paddingMobile;
      @include paddingBottom;

      @include tablet {
        @include paddingBig;
      }

      &--item {
        width: 100%;
        margin-bottom: 3rem;

        @include tablet-m {
          width: 47%;
        }

      }

      &--title {
        display: flex;
        width: fit-content;
        margin-bottom: 0.6rem;
        @include transition;

        &:hover {
          color: $orange;
          span {
             @include transition;

            color: $black;
          }
        }
      }

      &--description {
        p,h2,h3,h4,h5,h6 {
          margin-bottom: 0.6rem;
        }
      }

          li {
          position: relative;
          padding-left: 15px;
          list-style: none;

          @include desktop-sm {
              padding-left: 20px;
            }

          &::before {
            position: absolute;
            top: 12px;
            left: 0;
            content: '';
            background: $orange;
            transform: translateY(-50%);
            width: 8px;
            height: 8px;

            @include tablet {
              top: 15px;
            }

            @include desktop-sm {
              width: 10px;
              height: 10px;
              top: 17px;
            }

            @include desktop-l {
              top: 20px;
            }

            @include desktop-xl {
              top: 23px;
            }
          }
        }




  }




  &__link {
    display: flex;
    display: none;
    align-items: center;
    margin-top: 10px;
    width: fit-content;

      svg {
        margin-left: 8px;
        opacity: 0;
        transform: translateY(0);
        height: 14px;

        @include transition;


         @include tablet {
            height: 14px
          }

          @include desktop-sm {
            height: 16px;
          }

          @include desktop-l {
            height: 18px;
          }

          @include desktop-xl {
            height: 21px;
          }
      }

      &:hover {
        svg {
          opacity: 1;
        }
      }
  }
}
</style>
